// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2760%27 height=%2760%27 viewBox=%270 0 60 60%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg fill=%27none%27 fill-rule=%27evenodd%27%3E%3Cg fill=%27%23ffffff%27 fill-opacity=%270.03%27%3E%3Cpath d=%27M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z%27/%3E%3C/g%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Legal page layout ───────────────────────── */
.legal-hero {
  background: linear-gradient(135deg, #1e1b4b 0%, #4f46e5 100%);
  padding: 56px 20px 48px;
  position: relative;
  overflow: hidden;
}

.legal-hero::before {
  content: '';
  position: absolute;
  inset: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.legal-hero-inner {
  max-width: 760px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.legal-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: rgba(255,255,255,0.75);
  font-size: 0.88rem;
  font-weight: 600;
  text-decoration: none;
  margin-bottom: 20px;
  transition: color 0.15s;
}
.legal-back:hover { color: #fff; }

.legal-hero h1 {
  font-size: clamp(1.6rem, 4vw, 2.4rem);
  font-weight: 900;
  color: #fff;
  letter-spacing: -0.5px;
  margin-bottom: 8px;
}

.legal-updated {
  font-size: 0.82rem;
  color: rgba(255,255,255,0.6);
}

/* ── Content ─────────────────────────────────── */
.legal-body {
  max-width: 760px;
  margin: 0 auto;
  padding: 48px 20px 80px;
}

.legal-alert {
  background: #fef9c3;
  border: 1.5px solid #fde047;
  border-radius: 12px;
  padding: 16px 18px;
  font-size: 0.9rem;
  color: #713f12;
  line-height: 1.6;
  margin-bottom: 36px;
}
.legal-alert strong { display: block; margin-bottom: 4px; font-weight: 800; }

.legal-section {
  margin-bottom: 32px;
}

.legal-section h2 {
  font-size: 1.05rem;
  font-weight: 800;
  color: var(--text);
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 2px solid #eef2ff;
  display: flex;
  align-items: center;
  gap: 8px;
}

.legal-section h2 span {
  background: var(--grad);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.legal-section h3 {
  font-size: 0.92rem;
  font-weight: 700;
  color: #374151;
  margin: 16px 0 6px;
}

.legal-section p {
  font-size: 0.92rem;
  color: #4b5563;
  line-height: 1.75;
  margin-bottom: 10px;
}

.legal-section ul {
  margin: 6px 0 10px;
  padding-left: 0;
  list-style: none;
}

.legal-section ul li {
  font-size: 0.92rem;
  color: #4b5563;
  line-height: 1.7;
  padding-left: 18px;
  position: relative;
  margin-bottom: 4px;
}

.legal-section ul li::before {
  content: '•';
  position: absolute;
  left: 4px;
  color: var(--p1);
  font-weight: 700;
}

.legal-section ul li strong {
  color: #111827;
  font-weight: 700;
}

.legal-highlight {
  background: #eef2ff;
  border-left: 4px solid var(--p1);
  border-radius: 0 10px 10px 0;
  padding: 14px 16px;
  margin: 12px 0;
  font-size: 0.9rem;
  color: #3730a3;
  line-height: 1.65;
  font-weight: 600;
}

.legal-contact {
  background: #f9fafb;
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 20px 24px;
  margin-top: 40px;
}
.legal-contact h3 {
  font-size: 1rem;
  font-weight: 800;
  color: var(--text);
  margin-bottom: 10px;
}
.legal-contact p {
  font-size: 0.88rem;
  color: #4b5563;
  margin-bottom: 4px;
  line-height: 1.5;
}
.legal-contact a {
  color: var(--p1);
  text-decoration: none;
  font-weight: 600;
}

@media (max-width: 600px) {
  .legal-hero { padding: 44px 16px 36px; }
  .legal-body { padding: 32px 16px 60px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/LegalPage.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;EACE,6DAA6D;EAC7D,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mDAA8X;AAChY;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;AACzB;AACA,oBAAoB,WAAW,EAAE;;AAEjC;EACE,qCAAqC;EACrC,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,mDAAmD;AACnD;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA,sBAAsB,cAAc,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;;AAE5E;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc,uBAAuB,EAAE;EACvC,cAAc,uBAAuB,EAAE;AACzC","sourcesContent":["/* ── Legal page layout ───────────────────────── */\n.legal-hero {\n  background: linear-gradient(135deg, #1e1b4b 0%, #4f46e5 100%);\n  padding: 56px 20px 48px;\n  position: relative;\n  overflow: hidden;\n}\n\n.legal-hero::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\");\n}\n\n.legal-hero-inner {\n  max-width: 760px;\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n}\n\n.legal-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: rgba(255,255,255,0.75);\n  font-size: 0.88rem;\n  font-weight: 600;\n  text-decoration: none;\n  margin-bottom: 20px;\n  transition: color 0.15s;\n}\n.legal-back:hover { color: #fff; }\n\n.legal-hero h1 {\n  font-size: clamp(1.6rem, 4vw, 2.4rem);\n  font-weight: 900;\n  color: #fff;\n  letter-spacing: -0.5px;\n  margin-bottom: 8px;\n}\n\n.legal-updated {\n  font-size: 0.82rem;\n  color: rgba(255,255,255,0.6);\n}\n\n/* ── Content ─────────────────────────────────── */\n.legal-body {\n  max-width: 760px;\n  margin: 0 auto;\n  padding: 48px 20px 80px;\n}\n\n.legal-alert {\n  background: #fef9c3;\n  border: 1.5px solid #fde047;\n  border-radius: 12px;\n  padding: 16px 18px;\n  font-size: 0.9rem;\n  color: #713f12;\n  line-height: 1.6;\n  margin-bottom: 36px;\n}\n.legal-alert strong { display: block; margin-bottom: 4px; font-weight: 800; }\n\n.legal-section {\n  margin-bottom: 32px;\n}\n\n.legal-section h2 {\n  font-size: 1.05rem;\n  font-weight: 800;\n  color: var(--text);\n  margin-bottom: 10px;\n  padding-bottom: 8px;\n  border-bottom: 2px solid #eef2ff;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.legal-section h2 span {\n  background: var(--grad);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.legal-section h3 {\n  font-size: 0.92rem;\n  font-weight: 700;\n  color: #374151;\n  margin: 16px 0 6px;\n}\n\n.legal-section p {\n  font-size: 0.92rem;\n  color: #4b5563;\n  line-height: 1.75;\n  margin-bottom: 10px;\n}\n\n.legal-section ul {\n  margin: 6px 0 10px;\n  padding-left: 0;\n  list-style: none;\n}\n\n.legal-section ul li {\n  font-size: 0.92rem;\n  color: #4b5563;\n  line-height: 1.7;\n  padding-left: 18px;\n  position: relative;\n  margin-bottom: 4px;\n}\n\n.legal-section ul li::before {\n  content: '•';\n  position: absolute;\n  left: 4px;\n  color: var(--p1);\n  font-weight: 700;\n}\n\n.legal-section ul li strong {\n  color: #111827;\n  font-weight: 700;\n}\n\n.legal-highlight {\n  background: #eef2ff;\n  border-left: 4px solid var(--p1);\n  border-radius: 0 10px 10px 0;\n  padding: 14px 16px;\n  margin: 12px 0;\n  font-size: 0.9rem;\n  color: #3730a3;\n  line-height: 1.65;\n  font-weight: 600;\n}\n\n.legal-contact {\n  background: #f9fafb;\n  border: 1px solid var(--border);\n  border-radius: 14px;\n  padding: 20px 24px;\n  margin-top: 40px;\n}\n.legal-contact h3 {\n  font-size: 1rem;\n  font-weight: 800;\n  color: var(--text);\n  margin-bottom: 10px;\n}\n.legal-contact p {\n  font-size: 0.88rem;\n  color: #4b5563;\n  margin-bottom: 4px;\n  line-height: 1.5;\n}\n.legal-contact a {\n  color: var(--p1);\n  text-decoration: none;\n  font-weight: 600;\n}\n\n@media (max-width: 600px) {\n  .legal-hero { padding: 44px 16px 36px; }\n  .legal-body { padding: 32px 16px 60px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
